import {
  getChemicalColumnHeader,
  getCleanChemicalColumnValue,
  getDiseaseColumnValue,
  getDiseaseItemColumnHeader,
  getGeneColumnValue,
  getVariantColumnValue,
  getVariantItemColumnHeader,
} from './suggestionsTable.helpers';
import { formatSimilarityScore } from './formatSimilarityScore';

export const getExcelColumns = (searchType: string, selectedFilter: string) => {
  switch (searchType) {
    case 'DISEASES': {
      const cols = [
        {
          header: getDiseaseItemColumnHeader(selectedFilter),
          value: (r: any, q: string) => getDiseaseColumnValue(selectedFilter, r, q),
        },
        {
          header: selectedFilter === 'name' ? 'Disease CUI(s)' : 'UMLS Name(s)',
          value: (r: any) =>
            selectedFilter === 'name' ? r.normalizedId || 'Not available' : r.name || 'Not available',
        },
      ];

      if (selectedFilter !== 'name' && selectedFilter !== 'diseaseUMLSCUI') {
        cols.push({
          header: 'Disease CUI(s)',
          value: (r: any) => r.diseaseUMLSCUI || 'Not available',
        });
      }

      if (selectedFilter === 'name') {
        cols.push({
          header: 'UMLS Name(s)',
          value: (r: any) => r.normalizedName || 'Not available',
        });
        cols.push({
          header: 'Similarity Score',
          value: (r: any) => formatSimilarityScore(r.similarity),
        });
      }

      return cols;
    }

    case 'VARIANTS': {
      const cols = [
        {
          header: getVariantItemColumnHeader(selectedFilter),
          value: (r: any, q: string) => getVariantColumnValue(selectedFilter, r, q),
        },
        {
          header: 'Variant(s) Gene',
          value: (r: any) => r.geneSymbol || 'Not available',
        },
      ];

      if (selectedFilter !== 'strID') {
        cols.push({
          header: 'VARIANT rs number(s)',
          value: (r: any) => (Array.isArray(r.strID) ? r.strID.join(', ') : r.strID || 'Not available'),
        });
      }

      return cols;
    }

    case 'GENES': {
      const cols = [];

      if (selectedFilter === 'name') {
        cols.push(
          {
            header: 'Gene(s) Name',
            value: (r: any) => r.term || r.matchedText || 'Not available',
          },
          {
            header: 'Gene ID(s)',
            value: (r: any) => r.geneID || 'Not available',
          },
          {
            header: 'Gene Symbol(s)',
            value: (r: any) => r.normalizedName || r.term || 'Not available',
          },
          {
            header: 'Similarity Score',
            value: (r: any) => formatSimilarityScore(r.similarity),
          },
        );
        return cols;
      }

      if (selectedFilter === 'uniprotID') {
        cols.push(
          {
            header: 'Uniprot ID(s)',
            value: (r: any) => getGeneColumnValue(selectedFilter, r),
          },
          {
            header: 'Gene Symbol(s)',
            value: (r: any) => r.symbol || 'Not available',
          },
          {
            header: 'Gene ID(s)',
            value: (r: any) => r.geneID || 'Not available',
          },
        );
        return cols;
      }

      cols.push(
        {
          header: 'Gene Symbol(s)',
          value: (r: any) => r.symbol || 'Not available',
        },
        {
          header: 'Gene ID(s)',
          value: (r: any) => r.geneID || 'Not available',
        },
        {
          header: 'ENSEMBL ID(s)',
          value: (r: any) =>
            Array.isArray(r.ensembl_ids) ? r.ensembl_ids.join(', ') : r.ensembl_ids || 'Not available',
        },
      );

      return cols;
    }

    case 'CHEMICALS': {
      const cols = [
        {
          header: getChemicalColumnHeader(selectedFilter),
          value: (r: any) => getCleanChemicalColumnValue(selectedFilter, r),
        },
      ];

      if (selectedFilter === 'name') {
        cols.push({
          header: 'Chembl ID(s)',
          value: (r: any) => r.normalizedId || 'Not available',
        });
      } else {
        cols.push({
          header: 'Chembl(s) Name',
          value: (r: any) => r.chemPrefName || 'Not available',
        });
      }
      if (selectedFilter !== 'CHEMBL' && selectedFilter !== 'name') {
        cols.push({
          header: 'Chembl ID(s)',
          value: (r: any) => r.chemID || 'Not available',
        });
      }

      if (selectedFilter === 'name') {
        cols.push({
          header: 'UMLS Name(s)',
          value: (r: any) => r.normalizedName || 'Not available',
        });
        cols.push({
          header: 'Similarity Score',
          value: (r: any) => formatSimilarityScore(r.similarity),
        });
      }

      return cols;
    }
  }
};
